import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const sections = [
  {
    title: "1. Introduction",
    content: [
      'Welcome to this website and related services (the "Service"), operated by Trevionix LTD ("Company", "we", "our", or "us").',
      "Registered Office: International House, 12 Constance Street, London, E16 2DQ, United Kingdom. Email: support@trevionics.com. Phone: +44 7520 658798.",
      'These Terms of Use ("Terms") govern your access to and use of the Service, including any associated websites, mobile applications, and features.',
      "By accessing or using the Service, you agree to be bound by these Terms and our Privacy Policy. If you do not agree, please do not use the Service.",
    ],
  },
  {
    title: "2. Definitions",
    content: [
      '"Service" means the website, mobile applications, and all related functionality.',
      '"Company" refers to Trevionix LTD.',
      '"User" / "you" means any individual using the Service.',
      '"Content" means all materials, text, graphics, and media available through the Service.',
    ],
  },
  {
    title: "3. Eligibility",
    content: [
      "By using the Service, you confirm that:",
      "You are at least 18 years old or meet the minimum legal age in your jurisdiction. You have the legal capacity to enter into these Terms. You will comply with all applicable laws.",
    ],
  },
  {
    title: "4. Use of the Service",
    content: [
      "You agree to use the Service only for lawful purposes.",
      "You must not: violate any applicable laws or regulations; attempt unauthorized access to systems or data; interfere with the functionality or security of the Service; use automated systems (bots, scrapers) without permission; misuse the Service in a way that could harm other users or the Company.",
    ],
  },
  {
    title: "5. Subscriptions and Payments",
    content: [
      "Some features of the Service may require payment or subscription.",
      "Payments are processed through third-party platforms (e.g., Apple App Store). Subscriptions may automatically renew unless canceled. You can manage or cancel subscriptions through your Apple ID settings. All billing and refunds are handled according to Apple’s payment policies.",
    ],
  },
  {
    title: "6. Intellectual Property",
    content: [
      "All Content is owned by or licensed to the Company and protected by applicable laws.",
      "You are granted a limited, non-exclusive, non-transferable license to use the Service for personal purposes.",
      "You may not: copy, distribute, or modify Content without permission; use trademarks or branding without written consent.",
    ],
  },
  {
    title: "7. User Content",
    content: [
      "If you submit any content: you retain ownership; you grant us a limited right to use it to operate the Service; you confirm it does not violate any laws or third-party rights.",
    ],
  },
  {
    title: "8. Third-Party Services",
    content: [
      "The Service may include integrations or links to third-party services.",
      "We do not control and are not responsible for: third-party content; their privacy practices; their availability or reliability.",
      "Use of third-party services is at your own risk.",
    ],
  },
  {
    title: "9. Disclaimer",
    content: [
      'The Service is provided "as is" and "as available".',
      "We do not guarantee: accuracy or completeness of content; continuous or error-free operation; that the Service will meet your expectations.",
    ],
  },
  {
    title: "10. Limitation of Liability",
    content: [
      "To the fullest extent permitted by law, the Company is not liable for: indirect or consequential damages; loss of data, revenue, or business; issues arising from use or inability to use the Service.",
      "Nothing limits liability where prohibited by law.",
    ],
  },
  {
    title: "11. User Responsibility",
    content: [
      "You are responsible for: your use of the Service; your device security; any activity conducted under your usage.",
    ],
  },
  {
    title: "12. Privacy",
    content: [
      "Your use of the Service is governed by our Privacy Policy.",
      "We process personal data in accordance with applicable laws, including UK GDPR, where applicable.",
    ],
  },
  {
    title: "13. Changes to the Service",
    content: [
      "We may: update or modify the Service; change features or functionality; update these Terms.",
      "Continued use means acceptance of changes.",
    ],
  },
  {
    title: "14. Termination",
    content: [
      "We may suspend or terminate access if: you violate these Terms; required by law; necessary to protect the Service.",
    ],
  },
  {
    title: "15. Governing Law",
    content: [
      "These Terms are governed by the laws of England and Wales.",
    ],
  },
  {
    title: "16. Severability",
    content: [
      "If any part of these Terms is invalid, the remaining provisions remain in effect.",
    ],
  },
  {
    title: "17. Entire Agreement",
    content: [
      "These Terms represent the entire agreement between you and the Company.",
    ],
  },
  {
    title: "18. Contact",
    content: [
      "Trevionix LTD",
      "International House",
      "12 Constance Street",
      "London",
      "E16 2DQ",
      "United Kingdom",
      "Email: support@trevionics.com",
      "Phone: +44 7520 658798",
    ],
  },
];

export default function TermsPage() {
  return (
    <main className="min-h-screen bg-[#0d0d0d]">
      <Navbar />

      <section className="w-full pt-36 pb-16 md:pt-44 md:pb-20 px-6 md:px-10 lg:px-16">
        <p
          className="text-[11px] uppercase tracking-[0.28em] text-[#B8422E] mb-4"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          / Legal
        </p>
        <h1
          className="text-4xl md:text-5xl lg:text-[60px] font-extrabold text-white leading-[1.04] tracking-[-0.025em]"
          style={{ fontFamily: "'Public Sans', sans-serif" }}
        >
          Terms of Use
        </h1>
      </section>

      <section className="w-full px-6 md:px-10 lg:px-16 pb-24 md:pb-32">
        <div className="max-w-3xl">
          <div className="flex flex-col gap-8 text-white/60 text-base leading-relaxed" style={{ fontFamily: "'Public Sans', sans-serif" }}>
            {sections.map((section) => (
              <div key={section.title}>
                <h2
                  className="text-lg font-bold text-white mb-3"
                  style={{ fontFamily: "'Public Sans', sans-serif" }}
                >
                  {section.title}
                </h2>
                {section.content.map((p, i) => (
                  <p key={i} className={i > 0 ? "mt-3" : ""}>{p}</p>
                ))}
              </div>
            ))}
          </div>

          <p className="mt-12 text-xs text-[#6C7278]" style={{ fontFamily: "'Public Sans', sans-serif" }}>
            Last updated: May 2026
          </p>
        </div>
      </section>

      <Footer />
    </main>
  );
}